import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"


// Modules
import artisansModule from './Artisans/moduleArtisans'
import servicesModule from './Services/moduleServices'
import secteursModule from './Secteurs/moduleSecteurs'
import citiesModule from './Cities/moduleCities'
import clientsModule from './Clients/moduleClients'
import interventionsModule from './Interventions/moduleInterventions'
import subServicesModule from './SubServices/moduleSubServices'
import calendarModule from './Calendar/moduleCalendar'
import quotesModule from './Quotes/moduleQuotes'
import invoicesModule from './Invoices/moduleInvoices'
import productsModule from './Products/moduleProducts'
import authModule from './Auth/moduleAuth'
import autoInvoicesModule from './AutoInvoices/moduleAutoInvoices'
import statistiquesModule from './Statistiques/moduleStatistiques'
import usersModule from './Users/moduleUsers'
import historiquesModule from './Historiques/moduleHistoriques'



Vue.use(Vuex)


export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production',
    modules: {
      artisans : artisansModule,
      services : servicesModule,
      secteurs : secteursModule,
      cities : citiesModule,
      clients : clientsModule,
      interventions : interventionsModule,
      subservices : subServicesModule,
      calendar : calendarModule,
      quotes : quotesModule,
      invoices : invoicesModule,
      products : productsModule,
      auth : authModule,
      autoInvoices : autoInvoicesModule,
      statistiques : statistiquesModule,
      users : usersModule,
      historiques : historiquesModule,
    }
})
